module.exports = __webpack_public_path__ + "static/media/shopping.3b5288da.svg";